import React from "react";
import styles from "../inde.module.css";
import Skeleton from "react-loading-skeleton";

const SpecificationSkeleton = () => {
  const specs = [
    { label: "Make"},
    { label: "Model" },
    { label: "Interior color" },
    { label: "Exterior color" },
    { label: "Drive type" },
    { label: "Transmission" },
    { label: "Interior condition" },
    { label: "Exterior condition" },
    { label: "Reg. Year" },
    { label: "Mfg. Year" },
    { label: "Country" },
    { label: "Mileage" },
    { label: "Fuel type" },
    { label: "Engine CC." },
    { label: "Doors" },
    { label: "Seats" },
    { label: "Chassis No." },
    { label: "Model code" }
  ];

  return (
    <div className={styles.specContainer}>
      <h2 className={styles.specTitle}><Skeleton/></h2>

      <div className={styles.specList}>
        {specs.map((item, index) => (
          <div className={styles.specRow} key={index}>
            <span className={styles.specLabel}><Skeleton width={200}/></span>
            <span className={styles.specValue}><Skeleton width={100}/></span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SpecificationSkeleton;